import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { QueryClientProvider } from "@tanstack/react-query";
import { queryClient } from "./react-query/queryClient";
import App from "./App.jsx";
import { AuthProvider } from "./Context/AuthContext.jsx";
import ErrorBoundary from "./components/ErrorBoundary"; // ✅ استيراد ErrorBoundary
import "./i18n";
createRoot(document.getElementById("root")).render(
  <StrictMode>
    <QueryClientProvider client={queryClient}>
      <AuthProvider>
        <ErrorBoundary>
          <App />
        </ErrorBoundary>
      </AuthProvider>
    </QueryClientProvider>
  </StrictMode>
);
